<script>
export let is_open;


import { Player, Video, DefaultUi } from '@vime/svelte';


let video_url = '';


function closeModal() {
	is_open = false;
}

</script>



<style>

#jerseys-help-modal {

}

</style>



<div class="modal" id="jerseys-help-modal" class:is-active={is_open}>

	<div class="modal-background"></div>

	<div class="modal-card">

		<div class="modal-card-body">
			
			<Player
				theme="dark"
				style="--vm-player-theme: #cccccc;"
			>
				<Video
					crossOrigin
					poster="https://media.vimejs.com/poster.png"
				>
					<source 
						data-src="{video_url}" 
						type="video/mp4"
					/>
					<track 
						default 
						kind="subtitles" 
						src="https://media.vimejs.com/subs/english.vtt" 
						srclang="en" 
						label="English" 
					/>
			  	</Video>
			  
				<DefaultUi />
			</Player>

		</div>

	</div>

</div>




